import { Dispatch } from "redux";
import { CourseLanguageData } from "../../models/courseData";
import { courseLanguageService } from "../../api/index";

import {
  COURSE_LANGUAGES_REQUEST,
  COURSE_LANGUAGES_SUCCESS,
  COURSE_LANGUAGES_FAILURE,
  CourseLanguageActionTypes,
  CourseLanguagesRequestAction,
  CourseLanguagesFailureAction,
  CourseLanguagesSuccessAction,
} from "./types";

/**
 * Async action to fetch course languages.
 *
 * Dispatches a request action, then attempts to fetch course languages from the API.
 * If successful, dispatches success action with data.
 * If failed, dispatches failure action.
 *
 * @returns A thunk action for Redux.
 */
export const getCourseLanguages = () => {
  return async (dispatch: Dispatch<CourseLanguageActionTypes>) => {
    dispatch(courseLanguageRequest());
    courseLanguageService
      .getCourseLanguages()
      .then((response: CourseLanguageData[]) => {
        dispatch(courseLanguageSuccess(response));
      })
      .catch(() => {
        dispatch(courseLanguageFailure());
      });
  };
};

/**
 * Action creator for successfully fetched course languages.
 *
 * @param data - Array of course language objects.
 * @returns Action with type `COURSE_LANGUAGES_SUCCESS` and payload.
 */
export function courseLanguageSuccess(
  data: CourseLanguageData[]
): CourseLanguagesSuccessAction {
  return {
    type: COURSE_LANGUAGES_SUCCESS,
    data,
  };
}

/**
 * Action creator for initiating the course languages request.
 *
 * @returns Action with type `COURSE_LANGUAGES_REQUEST`.
 */
export function courseLanguageRequest(): CourseLanguagesRequestAction {
  return {
    type: COURSE_LANGUAGES_REQUEST,
  };
}

/**
 * Action creator for failed course languages request.
 *
 * @returns Action with type `COURSE_LANGUAGES_FAILURE`.
 */
export function courseLanguageFailure(): CourseLanguagesFailureAction {
  return {
    type: COURSE_LANGUAGES_FAILURE,
  };
}
